export default __webpack_public_path__ + "static/media/tinder_header_left.a68cf8c5.svg";